/**
 * @file: useShowAlert.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useAppNavigation } from '@euler/app/components/AppNavigationProvider';
import { useCallback } from 'react';
import { Alert, AlertButton, AlertOptions, Platform } from 'react-native';

export function useShowAlert() {
  const navigation = useAppNavigation();
  return useCallback(
    (args: {
      title: string;
      message?: string;
      buttons?: AlertButton[];
      options?: AlertOptions;
    }) => {
      if (Platform.OS === 'web') {
        navigation.navigate('_alert', args);
      } else {
        Alert.alert(args.title, args.message, args.buttons, args.options);
      }
    },
    [navigation],
  );
}
